<template>
  <div class="reports-container">
    <!-- Заголовки на сером фоне -->
    <div>

      <div v-if="!isCorrectPeriod" class="d-flex justify-content-center flex-wrap">
        <div class="error bad-period">
          <img
            :src="require(`../../../img/error.svg`)"
            alt="error"
            class="error__image__left"
          />
          <p>Период для сравнения установлен позже основного.<br>Пожалуйста, поменяйте их местами.</p>
          <img
            :src="require(`../../../img/error.svg`)"
            alt="error"
            class="error__image__right"
          />
        </div>
      </div>
    </div>

    <!-- Сообщение об ошибке на сером фоне -->
    <div v-if="showNoDataMessage" class="d-flex justify-content-center flex-wrap py-5">
      <div class="error">
        <img
          :src="require(`../../../img/error.svg`)"
          alt="error"
          class="error__image__left"
        />
        За выбранный период данные отсутствуют
        <img
          :src="require(`../../../img/error.svg`)"
          alt="error"
          class="error__image__right"
        />
      </div>
    </div>

    <!-- Общий прелоадер (показывается во время загрузки независимо от наличия данных) -->
    <div v-if="loading && !isAllDataLoaded" class="text-center py-5">
      <individual-preloader :loading="true"/>
    </div>

    <!-- Основной контент -->
    <div v-if="shouldShowContent">

      <!-- Карточки: Топ-n рекламодателей по SOV (каждый срез в своей карточке) -->
      <div v-if="reports.length > 0 && reports.some(r => r.loaded)" v-for="index in reports.length">
        <div v-if="reports[index - 1].loaded" class="data-section mb-4" :id="`sov-chart-${index}`">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h3 class="slice-title d-flex align-items-center">
              {{ reports[index - 1].title }}
              <tooltip
                :text="'<b>Топ рекламодателей по SOV</b> - диаграмма в виде кругов: Диаметр круга показывает долю рекламной выдачи (SOV), где рекламодатель присутствовал на странице. Высота расположения круга отражает среднюю позицию его объявлений на странице.'">
                <i class="fas fa-info-circle"
                   style="font-size: 14px; color: #6c757d; margin-left: 4px; margin-top: 5px;"></i>
              </tooltip>
            </h3>
            <download-with-table-button v-if="existsDownloadButton && reports[index - 1].items.length > 0"
                                        class="export-sov"
                                        :downloadReportType="downloadReportType"
                                        :urls="urls"
                                        :accordion="isSOVAccordionOpen"
                                        :chartContainerSelector="`#sov-chart-${index}`"
                                        tableTargetId="sov_dynamic_table_header"
                                        tabTargetId="tab-btn-1"
            ></download-with-table-button>
          </div>
          <div v-if="reports[index - 1].items.length > 0">
            <div class="chart-container">
              <transition name="chart-fade">
                <chart-pivot-template
                  :chart-data="reports[index - 1].chartBubbleData"
                  :options="options[index - 1]"
                  :animation-type="'center'"
                  :key="`bubble-chart-${index}-${bubbleLegendState.mainPeriod}-${bubbleLegendState.comparingPeriod}`"
                  class="bubble-chart-animation"
                />
              </transition>
              <individual-preloader :loading="bubbleChartLoading(reports[index - 1].id)"/>
            </div>

            <!-- Кастомная легенда для bubble графика -->
            <div class="d-flex flex-wrap bubble-container-legend w-100">
              <div class="container-legend-element" @click="toggleBubbleDataset('main')">
                <div class="bubble-legend-item" :class="{ 'legend-hidden': !bubbleLegendState.mainPeriod }">
                  <div class="bubble-circle"
                       style="background-color: rgba(61, 70, 161, 0.5); border: 1px solid rgba(61, 70, 161, 0.5);"></div>
                  <p>Основной период</p>
                </div>
              </div>
              <div class="container-legend-element"
                   v-if="reports[index - 1].response_comparing && reports[index - 1].response_comparing.length"
                   @click="toggleBubbleDataset('comparing')">
                <div class="bubble-legend-item" :class="{ 'legend-hidden': !bubbleLegendState.comparingPeriod }">
                  <div class="bubble-circle"
                       style="background-color: rgba(255, 55, 18, 0.5); border: 1px solid rgba(255, 55, 18, 0.5);"></div>
                  <p>Сравнительный период</p>
                </div>
              </div>
            </div>

            <p class="footnote">Диаметр круга: SOV - доля показов рекламодателя в рекламной выдаче</p>
          </div>

          <!-- Сообщение об отсутствии данных для конкретного среза -->
          <div
            v-if="reports[index - 1].items.length === 0"
            class="d-flex justify-content-center flex-wrap py-3"
          >
            <div class="error">
              <img
                :src="require(`../../../img/error.svg`)"
                alt="error"
                class="error__image__left"
              />
              За выбранный период данные отсутствуют
              <img
                :src="require(`../../../img/error.svg`)"
                alt="error"
                class="error__image__right"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Карточки динамики в одной строке -->
      <div v-if="reports.length > 0 && reports.some(r => r.loaded)" v-for="index in reports.length">
        <div v-if="
                Array.isArray(reports[index - 1].itemsDynamic) &&
                reports[index - 1].loaded
              "
        >
          <div v-if="reports[index - 1].itemsDynamic.length > 0" class="row">
            <!-- Карточка: Динамика средней позиции -->
            <div class="col-lg-6 mb-4">
              <div class="data-section h-100" :id="`dynamic-mean-position-${index}`">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h3 class="section-title d-flex align-items-center">
                    {{ reports[index - 1].titleDynamicMeanPosition || 'Динамика средней позиции' }}
                    <tooltip
                      :text="'<b>Динамика средней позиции</b> - линейный график, показывающий, как менялась средняя позиция объявлений по дням.'">
                      <i class="fas fa-info-circle"
                         style="font-size: 14px; color: #6c757d; margin-left: 4px; margin-top: 5px;"></i>
                    </tooltip>
                  </h3>
                  <download-with-table-button v-if="existsDownloadButton" class="export-dynamic"
                                              :downloadReportType="downloadReportTypeDynamic"
                                              :urls="urls"
                                              :accordion="isSOVAccordionOpen"
                                              :chartContainerSelector="`#dynamic-mean-position-${index}`"
                                              tableTargetId="sov_dynamic_table_header"
                                              tabTargetId="tab-btn-2"
                                              chartType="dynamic_mean_pos"
                  ></download-with-table-button>
                </div>

                <div class="dynamic-sov-line-chart-container">
                  <div class="dynamic-sov-line-chart-child w-100">
                    <div class="chart-container">
                      <transition name="chart-fade">
                        <line-chart-template
                          v-if="
                            reports[index - 1].loaded &&
                            reports[index - 1].itemsDynamic.length > 0
                          "
                          :chartData="reports[index - 1].chartLineDataDynamicMeanPosition"
                          :options="optionsDynamicMeanPosition"
                          :animation-type="'slow'"
                          :styles="myStyles"
                          :type="type"
                          :key="componentLineChartKey"
                          class="line-chart-mr-bottom dynamic-chart-animation"
                        />
                      </transition>
                      <individual-preloader :loading="dynamicMeanPositionLoading(reports[index - 1].id)"/>
                    </div>
                    <div class="d-flex flex-wrap dynamic-container-legend w-100">
                      <div
                        v-for="(item, item_index) in reports[index - 1].chartLineDataDynamicMeanPosition.datasets"
                        :id="'container-element-' + item_index"
                        class="container-legend-element"
                        @click="hideOneDataset(item)">
                        <div class="line"
                             :style="{'color': item.pointBackgroundColor, 'opacity': item.hidden ? 0.5 : 1}">
                          <p :style="{'opacity': item.hidden ? 0.5 : 1}">{{ item.label }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Карточка: Динамика SOV -->
            <div class="col-lg-6 mb-4">
              <div class="data-section h-100" :id="`dynamic-sov-${index}`">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h3 class="section-title d-flex align-items-center">
                    {{ reports[index - 1].titleDynamicSOV || 'Динамика SOV' }}
                    <tooltip
                      :text="'<b>Динамика SOV</b> (Share of Voice) - линейный график с изменением доли присутствия в верхних и нижних рекламных блоках по дням.'">
                      <i class="fas fa-info-circle"
                         style="font-size: 14px; color: #6c757d; margin-left: 4px; margin-top: 5px;"></i>
                    </tooltip>
                  </h3>
                  <download-with-table-button v-if="existsDownloadButton" class="export-dynamic"
                                              :downloadReportType="downloadReportTypeDynamic"
                                              :urls="urls"
                                              :accordion="isSOVAccordionOpen"
                                              :chartContainerSelector="`#dynamic-sov-${index}`"
                                              tableTargetId="sov_dynamic_table_header"
                                              tabTargetId="tab-btn-2"
                                              chartType="dynamic_sov"
                  ></download-with-table-button>
                </div>

                <div class="dynamic-sov-line-chart-container">
                  <div class="dynamic-sov-line-chart-child w-100">
                    <div class="chart-container">
                      <transition name="chart-fade">
                        <line-chart-template
                          v-if="
                            reports[index - 1].loaded &&
                            reports[index - 1].itemsDynamic.length > 0
                          "
                          :chartData="reports[index - 1].chartLineDataDynamicSOV"
                          :options="optionsDynamicSOV"
                          :animation-type="'slow'"
                          :styles="myStyles"
                          :type="type"
                          :key="componentLineChartKey"
                          class="line-chart-mr-bottom dynamic-chart-animation"
                        />
                      </transition>
                      <individual-preloader :loading="dynamicSOVLoading(reports[index - 1].id)"/>
                    </div>
                    <div class="d-flex flex-wrap dynamic-container-legend w-100">
                      <div
                        v-for="(item, item_index) in reports[index - 1].chartLineDataDynamicSOV.datasets"
                        :id="'container-element-' + item_index"
                        class="container-legend-element"
                        @click="hideOneDataset(item)">
                        <div class="line"
                             :style="{'color': item.pointBackgroundColor, 'opacity': item.hidden ? 0.5 : 1}">
                          <p :style="{'opacity': item.hidden ? 0.5 : 1}">{{ item.label }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Сообщение об отсутствии данных для динамических графиков конкретного среза -->
          <div
            v-if="reports[index - 1].itemsDynamic.length === 0"
            class="d-flex justify-content-center flex-wrap py-3"
          >
            <div class="error">
              <img
                :src="require(`../../../img/error.svg`)"
                alt="error"
                class="error__image__left"
              />
              За выбранный период данные отсутствуют
              <img
                :src="require(`../../../img/error.svg`)"
                alt="error"
                class="error__image__right"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Карточка: Табличные данные для графиков -->
      <div v-if="report_rows.length" class="data-section mb-4" :class="{ 'collapsed': !isSOVAccordionOpen }">
        <div v-if="reports.length > 0" v-for="index in reports.length">
          <div
            v-if="report_rows.length &&
              (reports[index - 1].loaded &&
              index === reports.length &&
              (reports[index - 1].items.length > 0 || reports.length > 1))
            "
          >
            <h2 id="sov_dynamic_table_header"
                @click="toggleSOVAccordion"
                class="section-title pointer"
                :class="{ closed: !isSOVAccordionOpen }"
            >Ключевые метрики: присутствие и качество
              <svg
                class="dashboard-accordion"
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                :class="{ rotated: isSOVAccordionOpen }"
              >
                <path
                  d="M0 3.2C0 1.43269 1.43269 0 3.2 0H34.8C36.5673 0 38 1.43269 38 3.2V34.8C38 36.5673 36.5673 38 34.8 38H3.2C1.43269 38 0 36.5673 0 34.8V3.2Z"
                  fill="#EBEDF3"/>
                <path d="M19 26L10 16L28 16L19 26Z" fill="#212529"/>
              </svg>
            </h2>
          </div>
        </div>
        <div class="sov-table" :class="{'sov-table-comparing': comparing}"
             v-if="report_rows.length && isSOVAccordionOpen" id="sov-table">
          <transition name="table-fade">
            <div class="tabs">
              <input type="radio" name="tab-btn" id="tab-btn-1" value="" checked>
              <label for="tab-btn-1"><span class="tab-label-text">Сводка за период</span></label>
              <input type="radio" name="tab-btn" id="tab-btn-2" value="">
              <label for="tab-btn-2"><span class="tab-label-text">Сравнение по дням</span></label>
              <input type="radio" name="tab-btn" id="tab-btn-3" value="">
              <div id="content-1" class="show">
                <download-button
                  :downloadReportType="downloadReportType"
                  :urls="urls"
                >
                </download-button>
                <div class="sov-table-header">
                  <div class="sov-table-header-cell">
                    <div>Рекламодатель</div>
                    <table-header-with-tooltip
                      label="SOV"
                      tooltip-text="Доля страниц, на которых объявления были показаны в рекламных блоках (как в верхнем, так и в нижнем)."
                    />
                    <table-header-with-tooltip
                      label="Средняя позиция"
                      tooltip-text="Среднее значение позиций объявлений среди всех показов в результатах поиска. Обычно в верхнем блоке рекламы отображается до 4 объявлений, все остальные отображаются в нижнем блоке."
                    />
                    <table-header-with-tooltip
                      label="Доля премиум-показов"
                      tooltip-text="Доля страниц, где объявления были в верхнем рекламном блоке над органикой."
                    />
                    <table-header-with-tooltip
                      class="header-label-pre-line"
                      label="Вхождение ключа
в заголовок"
                      tooltip-text="Доля объявлений рекламодателя, в заголовке которых встречается ключевое слово запроса."
                    />
                    <table-header-with-tooltip
                      class="header-label-pre-line"
                      label="Вхождение ключа
в текст"
                      tooltip-text="Доля объявлений рекламодателя, в тексте которых встречается ключевое слово запроса."
                    />
                  </div>
                </div>
                <div
                  v-for="(section, sectionIndex) in report_sections"
                  :key="sectionIndex"
                  :class="['sov-table-section', { 'sov-table-section-no-header': sectionIndex > 0 }]"
                >
                  <div v-if="section.sliceName" class="sov-section-title">{{ section.sliceName }}</div>
                  <results-table
                    :fields="fields"
                    :items="section.items"
                    :comparing="comparing"
                    :on-download-advertiser-report="downloadAdvertiserReport"
                  />
                </div>
              </div>
              <div id="content-2" class="show">
                <div class="advertisers__filters d-flex">
                  <div class="advertisers__filter">
                    <multiselect
                      :class="{
                      active: selectedDynamicAdvertiser1,
                      blue: true,
                    }"
                      v-model="selectedDynamicAdvertiser1"
                      deselect-label="✓"
                      select-label=""
                      selectedLabel="✓"
                      :options="setDynamicAdvertisers1"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      label="advertiser"
                      :searchable="false"
                      track-by="advertiserID"
                      :taggable="false"
                      openDirection="below"
                      :allowEmpty="false"
                      :disabled="false"
                      placeholder="Рекламодатель 1"
                    >
                    </multiselect>
                  </div>
                  <div class="vs">vs</div>
                  <div class="advertisers__filter">
                    <multiselect
                      :class="{
                      active: selectedDynamicAdvertiser2,
                      blue: true,
                    }"
                      v-model="selectedDynamicAdvertiser2"
                      deselect-label="✓"
                      select-label=""
                      selectedLabel="✓"
                      :options="setDynamicAdvertisers2"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      label="advertiser"
                      :searchable="false"
                      track-by="advertiserID"
                      :taggable="false"
                      openDirection="below"
                      :allowEmpty="false"
                      :disabled="false"
                      placeholder="Рекламодатель 2"
                    >
                    </multiselect>
                  </div>
                  <download-button
                    :downloadReportType="downloadReportTypeDynamic"
                    :urls="urls"
                  >
                  </download-button>
                </div>
                <div class="dynamic-table-header">
                  <div class="dynamic-table-header-cell">
                    <div class="col-1">Дата</div>
                    <div class="col-2">{{ selectedDynamicAdvertiser1.advertiser }}</div>
                    <div class="col-2">{{ selectedDynamicAdvertiser2.advertiser }}</div>
                  </div>
                </div>
                <results-table
                  :fields="fieldsDynamic"
                  :items="report_rows_dynamic"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
      <!-- Карточка: Статистика по ключевым словам -->
      <div v-if="report_rows.length" class="data-section mb-4" :class="{ 'collapsed': !isKeywordsAccordionOpen }"
           id="keywords-table">
        <h3 @click="toggleKeywordsAccordion"
            class="section-title pointer"
            :class="{ closed: !isKeywordsAccordionOpen }"
        >Статистика по ключевым словам
          <svg
            class="dashboard-accordion"
            xmlns="http://www.w3.org/2000/svg"
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            :class="{ rotated: isKeywordsAccordionOpen }"
          >
            <path
              d="M0 3.2C0 1.43269 1.43269 0 3.2 0H34.8C36.5673 0 38 1.43269 38 3.2V34.8C38 36.5673 36.5673 38 34.8 38H3.2C1.43269 38 0 36.5673 0 34.8V3.2Z"
              fill="#EBEDF3"/>
            <path d="M19 26L10 16L28 16L19 26Z" fill="#212529"/>
          </svg>
        </h3>
        <div class="kw_stats__filters d-flex" v-if="isKeywordsAccordionOpen && (keywordsStats.length || competitors.length)">
          <div class="kw_stats__filter kw_stats__filter__adv">
            <multiselect
              :class="{
                active: competitorsFilter,
                blue: true,
              }"
              v-model="competitorsFilter"
              deselect-label="✓"
              select-label=""
              selectedLabel="✓"
              :options="competitors"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              label="title"
              :searchable="false"
              track-by="id"
              :taggable="false"
              openDirection="below"
              :allowEmpty="false"
              @input="selectCompetitorsFilter"
              @select="onCompetitorSelect"
              :disabled="false"
              placeholder="Рекламодатель"
            >
            </multiselect>
          </div>
          <div class="kw_stats__filter__percshowup">
            <multiselect
              :value="filterBy"
              :options="filterByOptions"
              :searchable="false"
              :show-labels="false"
              label="title"
              track-by="value"
              placeholder="Сортировать по"
              :allowEmpty="false"
              @input="selectFilterBy"
              :close-on-select="true"
              :disabled="false"
            >
            </multiselect>
          </div>
          <div class="kw_stats__filter">
            <multiselect
              :value="topPersistenceFilterType"
              :options="topPersistenceFilterTypeOptions"
              :searchable="false"
              :show-labels="false"
              label="title"
              track-by="title"
              placeholder="Больше или меньше"
              :close-on-select="true"
              :allowEmpty="false"
              @input="selectTopPersistenceFilterType"
              :disabled="false"
              class="results_in_top_filter_options"
            >
            </multiselect>
          </div>
          <div class="kw_stats__filter">
            <input
              style="font-style: italic"
              v-model="topPersistenceFilterValueModel"
              placeholder="Значение"
              type="number"
              class="form-control kw_stats__filter__value"
            />
          </div>
          <div class="kw_stats__filter__apply">
            <b-button @click="ActivateFilter" class="btn-success float-right">
              Применить
            </b-button>
          </div>
          <div class="kw_stats__filter__reset">
            <b-button
              @click="resetFilter"
              class="btn-warning float-right"
              :style="{ visibility: isFilterActive ? 'visible' : 'hidden' }"
            >
              Сбросить
            </b-button>
          </div>
          <download-button
            :downloadReportType="downloadReportTypeKeywords"
            :urls="[keywordsDownloadLink]"
          ></download-button>
        </div>
        <div class="overflow-auto">
          <results-table id="kw-stats-table"
                         :fields="fieldsKeywords"
                         :items="keywordsStats"
                         :per-page="pageItems"
                         :current-page="currentPaginationPage"
                         v-if="keywordsStats.length && isKeywordsAccordionOpen"
          />
          <b-pagination
            v-model="paginationPageModel"
            :total-rows="rowsPaginationNumber"
            :per-page="pageItems"
            aria-controls="kw-stats-table"
            :first-number="true"
            :last-number="true"
            v-if="keywordsStats.length && isKeywordsAccordionOpen"/>
          <p v-if="isKeywordsAccordionOpen && !loadingKeywords && !keywordsStats.length && competitors.length" class="text-muted py-3 mb-0">
            За выбранный период по выбранному рекламодателю нет данных по ключевым словам. Попробуйте выбрать другого рекламодателя в фильтре выше.
          </p>
        </div>
        <preloader v-if="loadingKeywords && isKeywordsAccordionOpen"/>
      </div>
    </div>
  </div>
</template>


<script>
import ChartPivotTemplate from "./PivotChart";
import LineChartTemplate from "./LineChart";
import ResultsTable from "./TableResults";
import DownloadButton from "../../common/DownloadButton";
import DownloadMultiselectButton from "../../common/DownloadMultiselectButton";
import DownloadWithTableButton from "../../common/DownloadWithTableButton";
import DownloadOrGoToDynamicTable from "../../common/DownloadOrGoToDynamicTable";
import DownloadOrGoToSOVTable from "../../common/DownloadOrGoToSOVTable";
import ChartAPI from "../../common/chart-api";
import EventHubListenerMixin from "../../common/mixins/EventHubListener";
import Preloader from "../../common/Preloader";
import IndividualPreloader from "../../common/IndividualPreloader";
import Multiselect from "vue-multiselect";
import Tooltip from "../../common/Tooltip";
import TableHeaderWithTooltip from "../../common/TableHeaderWithTooltip";

import {mapActions, mapGetters} from "vuex";

const axios = require("axios").default;

export default {
  components: {
    LineChartTemplate,
    ChartPivotTemplate,
    ResultsTable,
    EventHubListenerMixin,
    Multiselect,
    DownloadButton,
    DownloadMultiselectButton,
    DownloadWithTableButton,
    DownloadOrGoToDynamicTable,
    DownloadOrGoToSOVTable,
    Preloader,
    IndividualPreloader,
    Tooltip,
    TableHeaderWithTooltip,
  },

  data() {
    return {
      fields: [
        {key: "advertiser", label: "Рекламодатель"},
        {key: "sov", label: "SOV"},
        {key: "meanPosition", label: "Средняя позиция"},
        {key: "special_share", label: "Доля премиум-показов"},
        {key: "pct_in_title", label: "Вхождение ключа\nв заголовок"},
        {key: "pct_in_content", label: "Вхождение ключа\nв текст"},
      ],
      fieldsDynamic: [
        {key: "date", label: "Дата"},
        {key: "sov1", label: "SOV"},
        {key: "meanPosition1", label: "Средняя позиция"},
        {key: "specialShare1", label: "Доля премиум-показов"},
        {key: "pctInTitle1", label: "Вхождение ключа\nв заголовок"},
        {key: "pctInContent1", label: "Вхождение ключа\nв текст"},
        {key: "sov2", label: "SOV"},
        {key: "meanPosition2", label: "Средняя позиция"},
        {key: "specialShare2", label: "Доля премиум-показов"},
        {key: "pctInTitle2", label: "Вхождение ключа\nв заголовок"},
        {key: "pctInContent2", label: "Вхождение ключа\nв текст"},
      ],
      errorMessage: "",
      comparing: false,
      downloadReportType: "export-sov",
      dateHeaderColour: "#EBEDF3",
      chartColours: [],
      componentLineChartKey: false,
      dateHeaderWhite: "#FFFFFF",
      urls: [],
      header: "Статистика по ключевым словам",
      ourLabels: "There are no active advertisers",
      events: ["updateData"],
      fieldsKeywords: [
        {key: "keyword", label: "Ключевое слово"},
        {key: "sov", label: "SOV"},
        {key: "meanPosition", label: "Средняя позиция"},
        {key: "resultsInTop", label: "Доля премиум-показов"},
      ],
      errorMessageKeywords: "",
      downloadReportTypeKeywords: "export-keywords-dynamic",
      downloadReportTypeDynamic: "export-dynamic-dashboard",
      isKeywordsAccordionOpen: false,
      isSOVAccordionOpen: false,
      isFilterActive: false,
      selectedDynamicAdvertiser1: null,
      selectedDynamicAdvertiser2: null,
      dynamicAdvertisers1: [],
      dynamicAdvertisers2: [],
      currentPage: 1,
      report_with_data: 0,
      // Состояние для кастомной легенды bubble графиков
      bubbleLegendState: {
        mainPeriod: true,
        comparingPeriod: true
      }
    };
  },
  computed: {
    isAllDataLoaded() {
      // Проверяем, есть ли хотя бы один загруженный отчет с данными
      if (!this.reports || this.reports.length === 0) {
        return false;
      }

      // Проверяем, есть ли хотя бы один отчет с данными
      const hasLoadedData = this.reports.some(report => {
        const isLoaded = report.loaded;
        const hasItems = report.items && report.items.length > 0;
        const hasDynamicItems = report.itemsDynamic && report.itemsDynamic.length > 0;

        return isLoaded && (hasItems || hasDynamicItems);
      });

      return hasLoadedData;
    },

    hasTableData() {
      // Проверяем, есть ли данные для таблиц
      return this.report_rows !== undefined && this.report_rows.length > 0;
    },

    showNoDataMessage() {
      // Показываем сообщение об отсутствии данных, если нет данных ни для графиков, ни для таблиц
      const hasGraphData = this.reports.length > 0 && this.reports.some(r => r.loaded && r.items !== undefined && r.items.length > 0);
      const hasDynamicData = this.reports.length > 0 && this.reports.some(r => r.loaded && r.itemsDynamic !== undefined && r.itemsDynamic.length > 0);
      const hasTableData = this.hasTableData;

      // Показываем сообщение только если есть загруженные отчеты, но нет данных ни для графиков, ни для таблиц
      return this.reports.length > 0 && this.reports.some(r => r.loaded) && !hasGraphData && !hasDynamicData && !hasTableData;
    },

    shouldShowContent() {
      // Показываем контент если есть данные для графиков ИЛИ таблиц, и нет сообщения об отсутствии данных
      return (this.isAllDataLoaded || this.hasTableData) && !this.showNoDataMessage;
    },

    ...mapGetters(["currentProjectId"]),
    ...mapGetters("sov_dashboard", ["reports", "report_rows", "report_sections", "loading", "isCorrectPeriod", "dynamicMeanPositionLoading", "dynamicSOVLoading", "bubbleChartLoading"]),
    ...mapGetters("keywords", [
      "keywordsDownloadLink",
      "keywordsStats",
      "topPersistenceFilterTypeOptions",
      "topPersistenceFilterType",
      "topPersistenceFilterValue",
      "filterBy",
      "filterByOptions",
      "loadingKeywords",
      "pageItems",
      "currentPaginationPage",
      "rowsPaginationNumber",
    ]),
    ...mapGetters(["competitors"]),
    ...mapGetters("filters", ["competitorsFilter", "resultsPeriod"]),

    report_rows_dynamic(state) {
      if (state.reports.length) {
        let el1 = this.selectedDynamicAdvertiser1 ? this.selectedDynamicAdvertiser1.advertiserID : null;
        let el2 = this.selectedDynamicAdvertiser2 ? this.selectedDynamicAdvertiser2.advertiserID : null;
        let rows = [];
        for (let report in state.reports) {
          let date = "";
          if (state.reports[report].slice_param) {
            date = `${state.reports[report].slice_param
              .charAt(0)
              .toUpperCase()}${state.reports[report].slice_param.slice(1)}`;
          }
          if (state.reports[report].itemsDynamic) {
            if (state.reports[report].itemsDynamic.length) {
              rows.push({
                date: date,
                meanPosition1: "Средняя позиция",
                sov1: "SOV",
                specialShare1: "Доля премиум-показов",
                pctInTitle1: "Вхождение ключа\nв заголовок",
                pctInContent1: "Вхождение ключа\nв текст",
                meanPosition2: "Средняя позиция",
                sov2: "SOV",
                specialShare2: "Доля премиум-показов",
                pctInTitle2: "Вхождение ключа\nв заголовок",
                pctInContent2: "Вхождение ключа\nв текст",
              })
            }
            for (let current_item = 0; current_item < state.reports[report].itemsDynamic.length; current_item++) {
              const d1 = state.reports[report].chartLineDataDynamicPctInTitle && state.reports[report].chartLineDataDynamicPctInTitle.datasets[el1];
              const d2 = state.reports[report].chartLineDataDynamicPctInContent && state.reports[report].chartLineDataDynamicPctInContent.datasets[el1];
              const d3 = state.reports[report].chartLineDataDynamicPctInTitle && state.reports[report].chartLineDataDynamicPctInTitle.datasets[el2];
              const d4 = state.reports[report].chartLineDataDynamicPctInContent && state.reports[report].chartLineDataDynamicPctInContent.datasets[el2];
              rows.push({
                date: state.reports[report].itemsDynamic[current_item],
                meanPosition1: (el1 !== null && state.reports[report].chartLineDataDynamicMeanPosition.datasets[el1] && state.reports[report].chartLineDataDynamicMeanPosition.datasets[el1].data[current_item] !== undefined)
                  ? `${state.reports[report].chartLineDataDynamicMeanPosition.datasets[el1].data[current_item]}` : '-',
                sov1: (el1 !== null && state.reports[report].chartLineDataDynamicSOV.datasets[el1] && state.reports[report].chartLineDataDynamicSOV.datasets[el1].data[current_item] !== undefined)
                  ? `${state.reports[report].chartLineDataDynamicSOV.datasets[el1].data[current_item]}%` : '-',
                specialShare1: (el1 !== null && state.reports[report].chartLineDataDynamicSpecialShare.datasets[el1] && state.reports[report].chartLineDataDynamicSpecialShare.datasets[el1].data[current_item] !== undefined)
                  ? `${state.reports[report].chartLineDataDynamicSpecialShare.datasets[el1].data[current_item]}%` : '-',
                pctInTitle1: (el1 !== null && d1 && d1.data[current_item] !== undefined && d1.data[current_item] !== null) ? `${d1.data[current_item]}%` : '-',
                pctInContent1: (el1 !== null && d2 && d2.data[current_item] !== undefined && d2.data[current_item] !== null) ? `${d2.data[current_item]}%` : '-',
                meanPosition2: (el2 !== null && state.reports[report].chartLineDataDynamicMeanPosition.datasets[el2] && state.reports[report].chartLineDataDynamicMeanPosition.datasets[el2].data[current_item] !== undefined)
                  ? `${state.reports[report].chartLineDataDynamicMeanPosition.datasets[el2].data[current_item]}` : '-',
                sov2: (el2 !== null && state.reports[report].chartLineDataDynamicSOV.datasets[el2] && state.reports[report].chartLineDataDynamicSOV.datasets[el2].data[current_item] !== undefined)
                  ? `${state.reports[report].chartLineDataDynamicSOV.datasets[el2].data[current_item]}%` : '-',
                specialShare2: (el2 !== null && state.reports[report].chartLineDataDynamicSpecialShare.datasets[el2] && state.reports[report].chartLineDataDynamicSpecialShare.datasets[el2].data[current_item] !== undefined)
                  ? `${state.reports[report].chartLineDataDynamicSpecialShare.datasets[el2].data[current_item]}%` : '-',
                pctInTitle2: (el2 !== null && d3 && d3.data[current_item] !== undefined && d3.data[current_item] !== null) ? `${d3.data[current_item]}%` : '-',
                pctInContent2: (el2 !== null && d4 && d4.data[current_item] !== undefined && d4.data[current_item] !== null) ? `${d4.data[current_item]}%` : '-',
              })
            }
          }
        }

        let final = [...new Set(rows)];
        for (let item of final) {
          item.sov1 = (item.sov1 === 'NaN%' || item.sov1 === 'null%' || item.sov1 === 'undefined%' || item.sov1 === '') ? '-' : item.sov1;
          item.meanPosition1 = (item.meanPosition1 === 'NaN' || item.meanPosition1 === 'null' || item.meanPosition1 === 'undefined' || item.meanPosition1 === '') ? '-' : item.meanPosition1;
          item.specialShare1 = (item.specialShare1 === 'NaN%' || item.specialShare1 === 'null%' || item.specialShare1 === 'undefined%' || item.specialShare1 === '') ? '-' : item.specialShare1;
          item.pctInTitle1 = (item.pctInTitle1 === 'NaN%' || item.pctInTitle1 === 'null%' || item.pctInTitle1 === 'undefined%' || item.pctInTitle1 === '') ? '-' : (item.pctInTitle1 || '-');
          item.pctInContent1 = (item.pctInContent1 === 'NaN%' || item.pctInContent1 === 'null%' || item.pctInContent1 === 'undefined%' || item.pctInContent1 === '') ? '-' : (item.pctInContent1 || '-');
          item.sov2 = (item.sov2 === 'NaN%' || item.sov2 === 'null%' || item.sov2 === 'undefined%' || item.sov2 === '') ? '-' : item.sov2;
          item.meanPosition2 = (item.meanPosition2 === 'NaN' || item.meanPosition2 === 'null' || item.meanPosition2 === 'undefined' || item.meanPosition2 === '') ? '-' : item.meanPosition2;
          item.specialShare2 = (item.specialShare2 === 'NaN%' || item.specialShare2 === 'null%' || item.specialShare2 === 'undefined%' || item.specialShare2 === '') ? '-' : item.specialShare2;
          item.pctInTitle2 = (item.pctInTitle2 === 'NaN%' || item.pctInTitle2 === 'null%' || item.pctInTitle2 === 'undefined%' || item.pctInTitle2 === '') ? '-' : (item.pctInTitle2 || '-');
          item.pctInContent2 = (item.pctInContent2 === 'NaN%' || item.pctInContent2 === 'null%' || item.pctInContent2 === 'undefined%' || item.pctInContent2 === '') ? '-' : (item.pctInContent2 || '-');
        }
        return final;
      }
    },

    paginationPageModel: {
      get() {
        return this.currentPaginationPage;
      },
      set(value) {
        this.selectCurrentPaginationPage(value);
        this.fetchKeywordsStats()
      }
    },

    existsDownloadButton() {
      for (let report of this.reports) {
        if (report.items && report.items.length !== 0) {
          return true;
        }
      }
      return false;
    },

    options() {
      if (this.reports.length) {
        this.urls = [];

        let options_arr = [];
        this.errorMessage = "";
        let reports = this.reports;
        this.tableRowColouring();
        this.comparing = false;
        for (let report_pk in this.reports) {
          let negativeExpansion = 0;
          let positiveExpansion = 0;
          if (reports[report_pk].chartBubbleData && reports[report_pk].chartBubbleData.datasets && reports[report_pk].chartBubbleData.datasets.length) {
            for (let dataset of reports[report_pk].chartBubbleData.datasets) {
              for (let currentData of dataset.data) {
                if ((currentData.y - currentData.r / 20) < negativeExpansion) {
                  negativeExpansion = Math.ceil(currentData.y - currentData.r / 20);
                }
                if ((currentData.y + currentData.r / 20) > positiveExpansion) {
                  positiveExpansion = Math.ceil(currentData.y + currentData.r / 20);
                }
              }
            }
          }
          // Режим сравнения: есть данные за сравнительный период ИЛИ включён сравнительный период (тогда показываем серые нули)
          if (
            (reports[report_pk].response_comparing !== undefined && reports[report_pk].response_comparing.length) ||
            reports[report_pk].query_comparing
          ) {
            this.comparing = true;
          }
          if (reports[report_pk].query) {
            let result_url = reports[report_pk].query;
            if (reports[report_pk].query_comparing) {
              let start_date_other = this.getParameterByName(
                "start_date",
                reports[report_pk].query_comparing
              );
              let end_date_other = this.getParameterByName(
                "end_date",
                reports[report_pk].query_comparing
              );
              result_url += `&other_start_date=${start_date_other}&other_end_date=${end_date_other}`;
            }
            this.urls.push(result_url);
          }

          if (this.reports[report_pk].loaded) {
            let labels = this.reports[report_pk].labels;
            let labelsNumber = labels.length;
            let lengthData = labelsNumber;
            options_arr.push({
              scales: {
                yAxes: [
                  {
                    borderDash: [8, 8],
                    ticks: {
                      min: negativeExpansion,
                      max: positiveExpansion,
                      precision: 1,
                      stepSize: 1,
                      fontColor: "#6C757D",
                      fontSize: 12,
                      beginAtZero: true,
                      reverse: true,
                      callback: function (value) {
                        if (value >= 0) {
                          return value;
                        }
                        return "";
                      },
                    },
                    gridLines: {
                      color: "#EBEDF3",
                      display: true,
                      circular: true,
                      borderDash: [8, 8],
                      zeroLineWidth: 1,
                      zeroLineColor: "#EBEDF3",
                    },
                    scaleLabel: {
                      display: true,
                      fontSize: 14,
                      fontColor: "#6C757D",
                      fontStyle: 700,
                      fontWeight: 700,
                      labelString: "Средняя позиция",
                      padding: {left: 20},
                    },
                  },
                ],
                xAxes: [
                  {
                    ticks: {
                      fontColor: "#6C757D",
                      fontSize: 12,
                      min: 0,
                      max: labelsNumber + 1,
                      stepSize: 1,
                      beginAtZero: false,
                      callback: function (value, index, values) {
                        // index -= 1
                        if (index - 1 < lengthData && labels[index - 1]) {
                          let advertiserLabel = `${labels[index - 1]}`;
                          if (advertiserLabel) {
                            return advertiserLabel;
                          }
                        }
                        return ""; //else
                      },
                    },
                    scaleLabel: {
                      display: true,
                      fontSize: 14,
                      fontColor: "#6C757D",
                      fontStyle: 700,
                      fontWeight: 700,
                    },
                    gridLines: {
                      color: "#EBEDF3",
                      display: true,
                      circular: true,
                      borderDash: [8, 8],
                      zeroLineWidth: 0,
                    },
                  },
                ],
              },
              legend: {
                display: false,
              },

              tooltips: {
                enabled: true,
                mode: "single",
                displayColors: false,
                callbacks: {
                  label: function (tooltipItems, data) {
                    // Используем данные напрямую из текущего dataset
                    const datasetIndex = tooltipItems.datasetIndex;
                    const dataIndex = tooltipItems.index;

                    // Проверяем, что данные доступны
                    if (!data || !data.datasets || !data.datasets[datasetIndex] || !data.datasets[datasetIndex].data) {
                      return [];
                    }

                    // Получаем данные напрямую из текущего dataset
                    const currentData = data["datasets"][datasetIndex]["data"][dataIndex];

                    if (!currentData) {
                      return [];
                    }

                    let sovValue = currentData["sov"];
                    let sovLabel = sovValue !== undefined
                      ? `SOV: ${(parseFloat(sovValue) * 100).toFixed(0)}%`
                      : "";
                    let specialShareValue = currentData["special_share"];
                    let specialShareLabel = specialShareValue !== undefined
                      ? `Доля премиум-показов: ${(parseFloat(specialShareValue) * 100).toFixed(0)}%`
                      : "";

                    let bubbleLabel = [
                      `${currentData["advertiser_title"]}`,
                      sovLabel,
                      `Ср. позиция: ${parseFloat(tooltipItems.value).toFixed(1)}`,
                      specialShareLabel,
                    ];

                    // Определяем период по datasetIndex напрямую
                    const isComparingDataset = data["datasets"][datasetIndex]["label"].includes("(сравнение)");

                    if (isComparingDataset) {
                      const comparingDate = reports[report_pk].date_comparing;
                      if (comparingDate && comparingDate.trim() !== '') {
                        bubbleLabel.push(`Период: ${comparingDate}`);
                      } else {
                        bubbleLabel.push(`Период: ${reports[report_pk].date}`);
                      }
                    } else {
                      bubbleLabel.push(`Период: ${reports[report_pk].date}`);
                    }
                    return bubbleLabel;
                  },
                },
              },
              responsive: true,
              maintainAspectRatio: false,
              height: 200,
              animations: {
                tension: {
                  duration: 1000,
                  easing: 'linear',
                  from: 1,
                  to: 0,
                  loop: true
                }
              },
            });
          }
        }
        return options_arr;
      }
      return [];
    },

    optionsDynamicSOV() {
      return this.optionsDynamic("SOV");
    },

    optionsDynamicMeanPosition() {
      return this.optionsDynamic("MeanPosition");
    },

    myStyles() {
      return {
        responsive: true,
      };
    },

    type() {
      return {type: "line"};
    },

    topPersistenceFilterValueModel: {
      get() {
        return this.topPersistenceFilterValue;
      },
      set(value) {
        this.selectTopPersistenceFilterValue(value);
      },
    },

    period() {
      if (this.reports.length) {
        this.urls = [];
        this.errorMessage = "";
        let reports = this.reports;
        if (reports[0].query) {
          let startDate = this.getParameterByName(
            "start_date",
            reports[0].query
          )
            .split("-")
            .reverse()
            .join(".");
          let endDate = this.getParameterByName("end_date", reports[0].query)
            .split("-")
            .reverse()
            .join(".");
          return `за период ${startDate} - ${endDate}`;
        }
      }
    },

    setDynamicAdvertisers1() {
      this.dynamicAdvertisers1 = [];
      if (this.reports.length) {
        for (let j = 0; j < this.reports.length; j++) {
          if (this.reports[j].items.length) {
            this.report_with_data = j;
            break;
          }
        }
        for (let i = 0; i < this.reports[this.report_with_data].chartLineDataDynamicSOV.datasets.length; i++) {
          this.dynamicAdvertisers1.push({
            advertiserID: i,
            advertiser: this.reports[this.report_with_data].chartLineDataDynamicSOV.datasets[i].label
          })
        }
        this.selectedDynamicAdvertiser1 = this.dynamicAdvertisers1[0] // set up preselected first advertiser
      }
      return this.dynamicAdvertisers1
    },

    setDynamicAdvertisers2() {
      this.dynamicAdvertisers2 = [];
      if (this.reports.length) {
        for (let i = 0; i < this.reports[this.report_with_data].chartLineDataDynamicSOV.datasets.length; i++) {
          this.dynamicAdvertisers2.push({
            advertiserID: i,
            advertiser: this.reports[this.report_with_data].chartLineDataDynamicSOV.datasets[i].label
          })
        }
        this.selectedDynamicAdvertiser2 = this.dynamicAdvertisers2[1] // set up preselected second advertiser
      }
      return this.dynamicAdvertisers2
    },
  },

  updated() {
    this.tableRowColouring();
  },

  watch: {
    reports: {
      handler(newVal, oldVal) {
        // Отслеживание изменений reports
      },
      deep: true
    },

    report_rows: {
      handler(newVal, oldVal) {
        // Отслеживание изменений report_rows
      },
      deep: true
    },

    keywordsStats: {
      handler(newVal, oldVal) {
        // Отслеживание изменений keywordsStats
      },
      deep: true
    }
  },

  async mounted() {
    await this.fetchKeywordsStats();
  },

  methods: {
    async downloadAdvertiserReport(advertiserId, advertiserTitle) {
      if (!this.currentProjectId || !this.reports.length || !this.reports[0].query) return;
      const startDate = this.getParameterByName("start_date", this.reports[0].query);
      const endDate = this.getParameterByName("end_date", this.reports[0].query);
      if (!startDate || !endDate) return;
      const studObj = new ChartAPI();
      await studObj.getAdvertiserUrlsReport(this.currentProjectId, advertiserId, startDate, endDate);
    },

    getSOVAdvertisersCount() {
      if (this.reports.length > 0 && this.reports[0].items && this.reports[0].items.length > 0) {
        return this.reports[0].items.length;
      }
      return 0;
    },

    hideOneDataset(item) {
      item.hidden = !item.hidden;
      this.componentLineChartKey = !this.componentLineChartKey
    },

    optionsDynamic(dynamicName) {
      if (this.reports.length) {
        let labels = this.reports[0].chartLineDataDynamicMeanPosition.labels;
        let lengthData = labels.length;
        let labelYString = "";
        let stepSize = 1;
        let minYvalue = 0;
        let reverseYAxis = false;
        if (dynamicName === "SOV") {
          labelYString = "SOV, %";
          stepSize = 20;
        } else {
          labelYString = "Средняя позиция";
          reverseYAxis = true; // Инвертируем ось Y для средней позиции
          minYvalue = 1;
        }
        return {
          responsive: true,
          maintainAspectRatio: false,
          bezierCurve: false,
          height: 200,
          legend: {
            display: false,
            align: "center",
            position: "bottom",
            labels: {
              boxWidth: 98,
              boxHeight: 8,
            },
          },
          scales: {
            yAxes: [
              {
                type: "linear",
                display: true,
                position: "left",
                beginAtZero: true,
                scaleLabel: {
                  display: true,
                  fontSize: 14,
                  fontColor: "#6C757D",
                  fontStyle: 700,
                  fontWeight: 700,
                  labelString: labelYString,
                },
                gridLines: {
                  color: "#EBEDF3",
                  display: true,
                  circular: true,
                  borderDash: [8, 8],
                  zeroLineWidth: 1,
                  zeroLineColor: "#EBEDF3",
                },
                ticks: {
                  precision: 0,
                  beginAtZero: dynamicName === "SOV",
                  reverse: reverseYAxis,
                  stepSize: stepSize,
                  min: minYvalue,
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  fontSize: 14,
                  fontColor: "#6C757D",
                  fontStyle: 700,
                  fontWeight: 700,
                },
                gridLines: {
                  color: "#EBEDF3",
                  display: true,
                  circular: true,
                  borderDash: [8, 8],
                  zeroLineWidth: 0,
                },
                ticks: {
                  beginAtZero: false,
                  fontSize: 12,
                  min: 1,
                  max: lengthData + 1,
                  stepSize: stepSize,
                  maxRotation: 45,
                  minRotation: 45,
                },
              },
            ],
          },
          plugins: {
            tooltip: {
              mode: "index",
              intersect: false,
            },
            title: {
              display: true,
              text: "Chart.js Line Chart",
            },
          },
          elements: {
            line: {
              fill: true,
              tension: 0.4, // Унифицируем с данными из store
              borderWidth: 1.6, // Унифицируем с данными из store
            },
            point: {
              radius: 3, // Унифицируем с данными из store
              hitRadius: 8,
              hoverRadius: 8,
              pointStyle: "circle",
            },
          },
        };
      }
      return [];
    },

    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    tableRowColouring() {
      let table = document.getElementsByTagName("table")[0];
      let dynamicDiv = document.getElementById("content-2");
      if (table) {
        let tBody = table.getElementsByTagName("tbody")[0];
        let tableRow = tBody.getElementsByTagName("tr");
        const tableHeaderRegExp =
          "\\d{2}.\\d{2}.\\d{4}\\s+-\\s+\\d{2}.\\d{2}.\\d{4}";
        const comparingTableHeaderRegExp =
          "\\d{2}.\\d{2}\\s+-\\s+\\d{2}.\\d{2}.\\d{4}";

        for (let item = 0; item < tableRow.length; item++) {
          if (new RegExp(tableHeaderRegExp).test(tableRow[item].textContent) ||
            new RegExp(comparingTableHeaderRegExp).test(tableRow[item].textContent)) {
            tableRow[item].style.background = this.dateHeaderColour; // date headers colour
          } else {
            if (item === 0) {
              tableRow[item].style.background = this.dateHeaderWhite; // date headers colour
            }
          }
        }
      }
      if (dynamicDiv) {
        let tableDynamic = dynamicDiv.getElementsByTagName("table")[0];
        if (tableDynamic) {
          let tBodyDynamic = tableDynamic.getElementsByTagName("tbody")[0];
          let tableRowDynamic = tBodyDynamic.getElementsByTagName("tr");
          for (let item = 0; item < tableRowDynamic.length; item++) {
            if (/\p{L}+/u.test(tableRowDynamic[item].textContent)) {
              tableRowDynamic[item].style.background = this.dateHeaderColour; // dynamic table subtitles colour
            }
          }
        }
      }
    },

    toggleKeywordsAccordion() {
      this.isKeywordsAccordionOpen = !this.isKeywordsAccordionOpen;
    },

    toggleSOVAccordion() {
      this.isSOVAccordionOpen = !this.isSOVAccordionOpen;
    },

    resetFilter() {
      this.topPersistenceFilterValueModel = null;
      this.isFilterActive = false;
      this.fetchKeywordsStats();
    },

    ActivateFilter() {
      this.fetchKeywordsStats();
      this.isFilterActive = true;
    },

    renderHeader(text) {
      return `${text}`;
    },

    log() {
      // Логирование состояния и опций
    },

    countOccurrences(string, subString, allowOverlapping) {
      string += "";
      subString += "";
      if (subString.length <= 0) return string.length + 1;

      var n = 0,
        pos = 0,
        step = allowOverlapping ? 1 : subString.length;

      while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
          ++n;
          pos += step;
        } else break;
      }
      return n;
    },

    // Методы для управления кастомной легендой bubble графиков
    toggleBubbleDataset(period) {
      if (period === 'main') {
        this.bubbleLegendState.mainPeriod = !this.bubbleLegendState.mainPeriod;
        this.updateBubbleDatasetsVisibility();
      } else if (period === 'comparing') {
        this.bubbleLegendState.comparingPeriod = !this.bubbleLegendState.comparingPeriod;
        this.updateBubbleDatasetsVisibility();
      }
    },

    updateBubbleDatasetsVisibility() {
      // Обновляем видимость datasets для всех отчетов
      for (let report of this.reports) {
        if (report.chartBubbleData && report.chartBubbleData.datasets) {
          for (let i = 0; i < report.chartBubbleData.datasets.length; i++) {
            const dataset = report.chartBubbleData.datasets[i];
            const isComparingDataset = dataset.label && dataset.label.includes('(сравнение)');

            if (isComparingDataset) {
              dataset.hidden = !this.bubbleLegendState.comparingPeriod;
            } else {
              dataset.hidden = !this.bubbleLegendState.mainPeriod;
            }
          }
        }
      }

      // Принудительно обновляем графики через изменение ключа компонента
      this.$nextTick(() => {
        // Находим все компоненты ChartPivotTemplate и обновляем их
        const chartComponents = this.$children.filter(child =>
          child.$options.name === 'ChartPivotTemplate'
        );

        chartComponents.forEach(component => {
          if (component.renderBubbleChart) {
            component.renderBubbleChart();
          }
        });
      });
    },

    onCompetitorSelect(selectedCompetitor) {
      this.selectCompetitorsFilter(selectedCompetitor);
      this.fetchKeywordsStats();
    },

    ...mapActions("keywords", [
      "fetchKeywordsStats",
      "selectTopPersistenceFilterType",
      "selectTopPersistenceFilterValue",
      "selectFilterBy",
      "selectPaginationPageNumber",
      "selectCurrentPaginationPage"
    ]),
    ...mapActions("filters", ["selectCompetitorsFilter"]),
    ...mapActions("sov_dashboard", ["fetchSovReports"]),
  },
};
</script>
